import GTM from '../gtm/gtm';

export default class PhoneButton {
    constructor(element, w) {
        this.window = w || window;
        this.$element = $(element);
        this.phoneNum = this.$element.data('phone');
        this.$textElement = this.$element.find('[data-call-text]');
        this.trackingGTM = new GTM();
        this.trackingGTM.init();
        this.breakpoint = 767;
    }

    _call() {
        this.window.open(`tel:${this.phoneNum}`, '_self');
    }

    _reveal(e) {
        e.preventDefault();
        this.$textElement.text(this.phoneNum);
        this.$element.off('click.phoneReveal');
        this.$element.on('click.phoneCall', $.proxy(this, '_call'));
    }

    click(e) {
        this.trackingGTM.trackEvent('R2SPhoneBegin', '');
        if (window.matchMedia(`(max-width: ${this.breakpoint}px)`).matches) {
            this._call.call(this);
        } else {
            this._reveal.call(this, e);
        }
    }

    setListeners() {
        this.$element
            .off('click.phoneReveal', '', $.proxy(this, 'click'))
            .on('click.phoneReveal', $.proxy(this, 'click'));
    }

    init() {
        this.setListeners();
    }
}
